module.exports = __webpack_public_path__ + "static/media/painter.9fda8f76.jpg";